import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import AboutPillars from "@/components/AboutPillars";
import DivisionsOverview from "@/components/DivisionsOverview";
import Offices from "@/components/Offices";
import Leadership from "@/components/Leadership";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-[#FAFAF7] text-[#0B1A36]">
      <Navigation />
      <Hero />
      <AboutPillars />
      <DivisionsOverview />
      <Offices />
      <Leadership />
      <ContactSection />
      <Footer />
    </main>
  );
}
